import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");

// Vorgerendertes HTML (Docker-Deployment) liefert Crawlern und Besuchern sofort
// Inhalt; React übernimmt anschließend per Client-Render. Bewusst KEIN
// hydrateRoot: zeit-/zustandsabhängige Komponenten (Öffnungszeiten, Consent,
// Animationen) erzeugen sonst Hydration-Mismatches mit toten Buttons.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
